import styled, { css } from "styled-components";
import { IButtonProps } from "./index.tsx";

export const Button = styled.button<{
  $variant: IButtonProps["variant"];
  $color: IButtonProps["color"];
  $size: IButtonProps["size"];
  $fullWidth?: boolean;
  $disabled?: boolean;
  $isIcon?: boolean;
}>`
  ${({ $variant, $color, $size, theme, $fullWidth, $disabled, $isIcon }) => {
      let backgroundColor = "";
      let backgroundHoverColor = "";

      let color = "";
      let fontHoverColor = "";

      let borderColor = "";
      let borderHoverColor = "";

      let minHeight = 0;
      let gap = 0;
      let padding = 0;
      let fontSize = 0;

      let colorStore = theme.colors?.[$color || ""] || {
          default: theme.colors?.base,
          100: theme.colors?.base,
          200: theme.colors?.base,
          300: theme.colors?.base,
          400: theme.colors?.base,
      };

      switch ($variant) {
          case "solid":
              if ($color === "default") {
                  backgroundColor = colorStore[0];
                  backgroundHoverColor = colorStore[100];
                  borderColor = colorStore[100];
                  color = colorStore.default;
              } else {
                  backgroundColor = colorStore.default;
                  backgroundHoverColor =
                          colorStore[400] === colorStore.default
                                  ? colorStore[300]
                                  : colorStore[400];
                  color = theme.colors?.base;
              }
              break;
          case "flat":
              backgroundColor = colorStore[50];
              backgroundHoverColor = colorStore[100];
              color = colorStore.default;
              break;
          case "outline":
              if ($color === "default") {
                  borderColor = colorStore[300];
                  backgroundHoverColor = colorStore[100];
                  color = colorStore.default;
              } else {
                  borderColor = colorStore.default;
                  backgroundHoverColor = colorStore[100];
                  color = colorStore.default;
              }
              break;

          case "light":
              backgroundColor = "transparent";
              backgroundHoverColor = colorStore[100];
              color = colorStore.default;
              break;
      }

      if ($disabled) {
          backgroundColor = theme.colors?.default[200];
          color = theme.colors?.default[400];
          borderColor = theme.colors?.default[200];
          backgroundHoverColor = theme.colors?.default[200];
          fontHoverColor = theme.colors?.default[400];
          borderHoverColor = theme.colors?.default[200];
      }

      switch ($size) {
          case "lg":
              padding = 24;
              minHeight = 48;
              gap = 8;
              fontSize = 18;
              break;
          case "md":
              padding = 16;
              minHeight = 40;
              gap = 8;
              fontSize = 16;
              break;
          case "sm":
              padding = 12;
              minHeight = 32;
              gap = 8;
              fontSize = 14;
              break;
          case "xs":
              padding = 8;
              minHeight = 24;
              gap = 6;
              fontSize = 12;
              break;
      }

      return css`
      white-space: nowrap;
      box-sizing: border-box;
      background: ${backgroundColor};
      color: ${color};
      box-shadow: inset 0 0 0 1px ${borderColor || backgroundColor};
      border-color: ${borderColor};
      padding: 0 ${$isIcon ? 0 : padding}px;
      min-height: ${minHeight}px;
      cursor: ${$disabled ? "default" : "pointer"};
      transition:
        background 0.2s ease-out,
        color 0.2s ease-out,
        box-shadow 0.2s ease-out,
        box-shadow 0.2s ease-out;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      font-size: ${fontSize}px;
      ${$fullWidth ? "width: 100%" : ""};
      text-align: center;
      gap: ${padding / 2}px;
      position: relative;
      font-weight: 550;

      ${$isIcon &&
      css`
        aspect-ratio: 1;
      `}
      &:hover {
        box-shadow: inset 0 0 0 1px
          ${borderColor || backgroundHoverColor || backgroundColor};
        background: ${backgroundHoverColor};
        color: ${fontHoverColor};
        border-color: ${borderHoverColor};
      }

      &:focus-visible {
        box-shadow: 0 0 0 4px ${({ theme }) => theme.colors?.outline};
      }
    `;
  }}
`;
